import React from 'react';
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Body1,
  Card,
  Subtitle2,
  type AccordionToggleData,
  type AccordionToggleEvent,
} from '@fluentui/react-components';
import { useHelpPageStyles } from '../../styles/HelpPage.styles';
import { FAQ_ITEMS } from '../../constants/helpContent';
import { useSessionStorageState } from '../../hooks/useSessionStorageState';

export const FAQ_OPEN_ITEMS_STORAGE_KEY = 'helpFaqOpenItems';

const DEFAULT_OPEN_ITEMS = [FAQ_ITEMS[0].id];

function parseOpenItems(raw: unknown): string[] | undefined {
  if (!Array.isArray(raw) || raw.some((id) => typeof id !== 'string')) return undefined;
  const known = new Set(FAQ_ITEMS.map((item) => item.id));
  return (raw as string[]).filter((id) => known.has(id));
}

export const FaqsTab: React.FC = () => {
  const styles = useHelpPageStyles();
  const [openItems, setOpenItems] = useSessionStorageState<string[]>(
    FAQ_OPEN_ITEMS_STORAGE_KEY,
    DEFAULT_OPEN_ITEMS,
    parseOpenItems,
  );

  const handleToggle = (_event: AccordionToggleEvent, data: AccordionToggleData) => {
    setOpenItems(data.openItems as string[]);
  };

  return (
    <Card className={styles.card}>
      <Accordion
        className={styles.accordion}
        multiple
        collapsible
        openItems={openItems}
        onToggle={handleToggle}
      >
        {FAQ_ITEMS.map((item) => (
          <AccordionItem key={item.id} value={item.id} className={styles.accordionItem}>
            <AccordionHeader>
              <Subtitle2>{item.question}</Subtitle2>
            </AccordionHeader>
            <AccordionPanel className={styles.accordionPanel}>
              <Body1>{item.answer}</Body1>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Card>
  );
};
